import { render } from "./ContentSection.vue?vue&type=template&id=2d0f1ecc&scoped=true"
import script from "./ContentSection.vue?vue&type=script&lang=js"
export * from "./ContentSection.vue?vue&type=script&lang=js"

import "./ContentSection.vue?vue&type=style&index=0&id=2d0f1ecc&lang=scss&scoped=true"

import exportComponent from "/var/www/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d0f1ecc"]])

export default __exports__